// eslint-disable-next-line import/prefer-default-export
export const chartTypes = {
  SWELL: 'SWELL',
  PERIOD: 'PERIOD',
  WIND: 'WIND',
  SST: 'SST',
  SEA_ICE: 'SEA_ICE',
  // PRESSURE: 'PRESSURE',
  TOPO: 'TOPO',
};

export const unitTypes = {
  IMPERIAL: 'e',
  METRIC: 'm',
};

export const numberOfForecastDays = {
  PREMIUM: 16,
  FREE: 2,
};



// WEBPACK FOOTER //
// ./src/constants.js